import * as React from "react";
import { Formik } from "formik";
import { styles } from "./styles";
import Box from "@mui/material/Box";
import Loader from "components/loader";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { Close } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import AnimateButton from "components/animateButton";
import {
  FormControl,
  FormHelperText,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import { AddCarType, getCarTypesListing } from "./action";
import { CarTypesSchema } from "utils/schema";

export default function AddCarTypes({ state, setState }: any) {
  const dispatch: any = useDispatch();

  const handleClose = () => setState(false);

  const handleOnSubmit = (values: any) => {
    setLoading(true);
    dispatch(
      AddCarType(values, () => {
        setLoading(false);
        setState(false);
        dispatch(getCarTypesListing());
      })
    );
  };
  const [loading, setLoading] = React.useState(false);

  return (
    <Modal
      open={state}
      aria-labelledby="add-category-modal-title"
      aria-describedby="add-category-modal-description"
    >
      <Box sx={styles.addCategory}>
        <Box sx={styles.headingBar}>
          <Typography sx={styles.heading_ac} variant="h3" component="h2">
            Add Car Type
          </Typography>
          <IconButton onClick={handleClose} sx={styles.icon}>
            <Close />
          </IconButton>
        </Box>
        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={CarTypesSchema}
          initialValues={{ carType: "" }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <FormControl
                sx={styles.inputBox}
                error={Boolean(touched.carType && errors.carType)}
              >
                <OutlinedInput
                  fullWidth
                  required
                  type="text"
                  name="carType"
                  onBlur={handleBlur}
                  onChange={({ target }: any) => {
                    let value = target.value;
                    setFieldValue(
                      "carType",
                      value.replace(/[0-9]+/g, "").trimStart()
                    );
                  }}
                  value={values.carType}
                  placeholder="Enter Car Type"
                  inputProps={{ maxLength: 15 }}
                />
                {touched.carType && errors.carType && (
                  <FormHelperText
                    error
                    id="standard-weight-helper-text-email-login"
                  >
                    {errors.carType}
                  </FormHelperText>
                )}
              </FormControl>
              <Box sx={styles.button}>
                <AnimateButton>
                  <Button
                    disableElevation
                    size="large"
                    type="submit"
                    variant="contained"
                    color="secondary"
                  >
                    {"Add Car Type"}
                  </Button>
                </AnimateButton>
              </Box>
            </form>
          )}
        </Formik>
        {loading && <Loader />}
      </Box>
    </Modal>
  );
}
